import * as React from 'react'
import { connect } from 'react-redux'

import { Form, Label, Input } from 'reactstrap'
import FormGroup from 'reactstrap/lib/FormGroup'

import { OptionsType, ValueType } from 'react-select/lib/types'

import { RootState } from '../../../store/rootReducer'
import { AccidentType } from 'src/lib/interfaces/AccidentType.interface'
import { AccidentStatus } from 'src/lib/interfaces/AccidentStatus.interface'
import { Location, Position } from '../../../lib/interfaces/Location.interface'
import { AccidentFilterParameters } from 'src/lib/interfaces/AccidentFilterParameters.interface'

import CustomSelect from 'src/common/CustomSelect.component'
import AccidentDefaultFilterDropdown from './AccidentDefaultFilterDropdown.component'

import * as appSelectors from 'src/store/app/selectors'

const get = require('lodash/get')
const first = require('lodash/first')

export interface AccidentFilterProps {
  locations?: Location[]
  positions?: Position[]
  accidentTypes?: AccidentType[]
  accidentStatus?: AccidentStatus[]
  getLocationWithId: (locationId: number) => Location|undefined
}

export interface AccidentFilterPassedProps {
  filterParams: AccidentFilterParameters
  onChange: (filters: AccidentFilterParameters) => void
}

class AccidentFilter extends React.PureComponent<AccidentFilterProps & AccidentFilterPassedProps> {
  constructor(props) {
    super(props)

    this.checkboxFilterChanged = this.checkboxFilterChanged.bind(this)
    this.multiSelectFilterChanged = this.multiSelectFilterChanged.bind(this)
    this.singleSelectFilterChanged = this.singleSelectFilterChanged.bind(this)
  }

  updateMultipleValuesFromFilterChange(values) {
    const { onChange, filterParams } = this.props
    const newFilterParams = {
      ...filterParams,
      ...values
    }
    
    onChange(newFilterParams)
  }

  updateValueFromFilterChange(propertyName: string, value: any) {
    this.updateMultipleValuesFromFilterChange({ [propertyName]: value })
  }

  checkboxFilterChanged(propertyName: string, event) {
    const value = event.target.value === 'on'
    this.updateValueFromFilterChange(propertyName, value)
  }

  singleSelectFilterChanged(propertyName: string, selectedOption: ValueType<any>) {
    this.updateValueFromFilterChange(propertyName, selectedOption.value)
  }

  multiSelectFilterChanged(propertyName: string, selectedOptions: OptionsType<any>) {
    this.updateValueFromFilterChange(propertyName, selectedOptions.map(({ value }) => value))
  }

  handleSelectLocation(values) {
    this.updateMultipleValuesFromFilterChange({
        location: values,
        position: undefined
    })
  }

  render() {
    const { locations, accidentTypes, accidentStatus, filterParams, getLocationWithId } = this.props

    const allLocationsOption = { id: undefined, code: 'ALL' }
    const allLocations = [
      allLocationsOption,
      ...(locations || [])
    ]

    const approvalSelectObjects: OptionsType<any> = [
      {value: 'APPROVED', label: 'Approved'},
      {value: 'DENIED', label: 'Denied'},
      {value: 'DISPUTING', label: 'Disputing'},
      {value: 'PENDING', label: 'Pending'}
    ]

    let currentPositions
    if (get(filterParams, 'location.length', 0) === 1) {
        const currentLocation = getLocationWithId(first(filterParams.location))
        currentPositions = currentLocation && currentLocation.locationPositions
    }

    return (
      <div>
        <div className="d-flex align-items-center mb-2">
          <h3 className="mb-0">Claim Search & Filter</h3>
          <AccidentDefaultFilterDropdown
            className="ml-3"
            onSelectFilters={(filters: AccidentFilterParameters) =>
              this.props.onChange(filters)
            }
          />
        </div>
        <Form>
          <FormGroup>
            <div className="row">
              <div className="col-3">
                <FormGroup>
                  <Label for="accident-type">Location</Label>
                  <CustomSelect
                    isMulti
                    options={allLocations}
                    style={{ width: '100%' }}
                    value={filterParams.location}
                    valueContainerStyle={{ textAlign: 'left' }}
                    getOptionValue={option => option && option.id }
                    getOptionLabel={option => option && option.code }
                    placeholderStyle={{ fontWeight: 'light', fontStyle: 'italic' }}
                    onChange={(value: number[]) => this.handleSelectLocation(value)}
                  />
                </FormGroup>
              </div>
              <div className="col-3">
                <FormGroup>
                  <Label for="accident-status">Status</Label>
                  <CustomSelect
                    isMulti
                    options={accidentStatus}
                    style={{ width: '100%' }}
                    value={filterParams.accidentStatus}
                    valueContainerStyle={{ textAlign: 'left' }}
                    getOptionValue={option => option && option.id }
                    getOptionLabel={option => option && option.name}
                    placeholderStyle={{ fontWeight: 'light', fontStyle: 'italic' }}
                    onChange={(value: number[]) => this.updateValueFromFilterChange('accidentStatus', value)}
                  />
                </FormGroup>
              </div>


              <div className="col-3">
                <FormGroup>
                  <Label for="accident-type">Type</Label>
                  <CustomSelect
                    isMulti
                    options={accidentTypes}
                    style={{ width: '100%' }}
                    value={filterParams.accidentTypes}
                    valueContainerStyle={{ textAlign: 'left' }}
                    getOptionValue={option => option && option.id }
                    getOptionLabel={option => option && option.name}
                    placeholderStyle={{ fontWeight: 'light', fontStyle: 'italic' }}
                    onChange={(value: number[]) => this.updateValueFromFilterChange('accidentTypes', value)}
                  />
                </FormGroup>
              </div>

              {get(filterParams, 'location.length', 0) === 1 &&
                <div className="col-3">
                  <FormGroup>
                    <Label for="accident-location-position">Position</Label>
                    <CustomSelect
                      isMulti
                      style={{ width: '100%' }}
                      options={currentPositions}
                      value={filterParams.locationPosition}
                      valueContainerStyle={{ textAlign: 'left' }}
                      getOptionValue={option => option && option.id }
                      getOptionLabel={option => option && option.name }
                      placeholderStyle={{ fontWeight: 'light', fontStyle: 'italic' }}
                      onChange={(value: number[]) => this.updateValueFromFilterChange('locationPosition', value)}
                    />
                  </FormGroup>
                </div>
              }

              <div className="col-3">
                <FormGroup>
                  <Label for="accident-claim-approval">Approval</Label>
                  <CustomSelect
                    isMulti
                    style={{ width: '100%' }}
                    options={approvalSelectObjects}
                    value={filterParams.managerApproval}
                    valueContainerStyle={{ textAlign: 'left' }}
                    getOptionLabel={option => option && option.label }
                    getOptionValue={option => option && option.value }
                    placeholderStyle={{ fontWeight: 'light', fontStyle: 'italic' }}
                    onChange={(value: number[]) => this.updateValueFromFilterChange('managerApproval', value)}
                  />
                </FormGroup>
              </div>
            </div>

          </FormGroup>

          <FormGroup>
            <div className="row">
              <div className="col-6">
                <h4>Loss Date Range</h4>

                <div className="row">
                  <div className="col-6">
                    <FormGroup>
                      <Label for="date-from">From</Label>
                      <Input
                        type="date"
                        value={filterParams.lossDateFrom}
                        onChange={e => this.updateValueFromFilterChange('lossDateFrom', e.target.value)}
                      />
                    </FormGroup>
                  </div>
                  <div className="col-6">
                      <FormGroup>
                        <Label for="date-to">To</Label>
                        <Input
                          type="date"
                          value={filterParams.lossDateTo}
                          onChange={e => this.updateValueFromFilterChange('lossDateTo', e.target.value)}
                        />
                      </FormGroup>
                  </div>
                </div>
              </div>

              {/* <div className="col-6">
                <h4>Paid Date Range</h4>
                <div className="row">
                  <div className="col-6">
                    <FormGroup>
                      <Label for="exampleDatetime">Datetime</Label>
                      <Input type="date" name="datetime" id="exampleDatetime" placeholder="datetime placeholder" onChange={e => this.updateValueFromFilterChange('paidDateFrom', e.target.value)} />
                    </FormGroup>
                  </div>
                  <div className="col-6">
                    <FormGroup>
                      <Label for="exampleDatetime">Datetime</Label>
                      <Input type="date" name="datetime" id="exampleDatetime" placeholder="datetime placeholder" onChange={e => this.updateValueFromFilterChange('paidDateTo', e.target.value)} />
                    </FormGroup>
                  </div>
                </div>
              </div> */}
            </div>
          </FormGroup>

          {/* <FormGroup>
            <h4>More Options:</h4>
            <div className="row">
              <div className="col-6">

                <div className="row">
                  <div className="col-6">
                    <FormGroup check>
                      <Label check>
                        <Input type="checkbox"
                        //  value={this.state.filterParams.hideDenied ? 'on' : 'off'}
                          onChange={(event) => this.checkboxFilterChanged('hideDenied', event)} />{' '}
                        Hire Denied by Managers
                      </Label>
                    </FormGroup>
                  </div>
                  <div className="col-6">
                    <FormGroup check>
                      <Label check>
                        <Input type="checkbox"
                          onChange={(event) => this.checkboxFilterChanged('includeResolvedClaims', event)} />{' '}
                        Include Resolved Claims
                      </Label>
                    </FormGroup>
                  </div>
                </div>
              </div>

              <div className="col-6">
                Sort By:
                <Select options={[{value:'Loss Date', label:'Loss Date'}, {value:'Paid Date', label:'Paid Date'}]} onChange={(event) => this.singleSelectFilterChanged('accidentStatus', event) } />
              </div>
            </div>
          </FormGroup>       */}
        </Form>
      </div>
    )
  }
}

const mapStateToProps = (state: RootState) => {
  return ({
    locations: state.app.locations,
    positions: state.app.positions,
    accidentTypes: state.accidents.accidentTypes,
    accidentStatus: state.accidents.accidentStatus,
    getLocationWithId: appSelectors.getLocationWithId(state)
  })
}

const mapDispatchToProps = (dispatch) => ({})

export default connect<{}, {}, AccidentFilterPassedProps>(mapStateToProps, mapDispatchToProps)(AccidentFilter)



// WEBPACK FOOTER //
// ./src/routes/accidents/components/AccidentFilter.component.tsx